import getInterventionsFromList from '@/services/api/internal/eDispatch/interventions.api';

function treatInterventionsResponse(idList, interventionsList) {
  return idList.map((propertyId) => ({
    propertyId,
    list: interventionsList.filter(
      (itv) => itv.property_id === propertyId && itv.scheduled_type === 'E'
    ),
  }));
}

export default function getInterventionsInfos(items) {
  let idList = items.map((item) => item.property_id);
  idList = idList.filter(
    (item, index) => idList.findIndex((id) => id === item) === index
  );
  return getInterventionsFromList(idList).then((interventionsList) =>
    treatInterventionsResponse(idList, interventionsList)
  );
}
